var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M467 28.355H45c-24.813 0-45 20.187-45 45v278.273c0 24.813 20.187 45 45 45h151.494v57.016h-22.587c-8.284 0-15 6.716-15 15s6.716 15 15 15h164.187c8.284 0 15-6.716 15-15s-6.716-15-15-15h-22.587v-57.016H467c24.813 0 45-20.187 45-45V73.355c0-24.813-20.187-45-45-45zm-181.494 425.29h-59.012v-57.016h59.012v57.016zM482 351.629c0 8.271-6.729 15-15 15H45c-8.271 0-15-6.729-15-15v-22.803h452v22.803zm0-52.803H30V73.355c0-8.271 6.729-15 15-15h422c8.271 0 15 6.729 15 15v225.471z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.275 216.892-40.633-27.741 40.633-27.741c6.842-4.671 8.602-14.004 3.931-20.846-4.67-6.841-14.004-8.601-20.846-3.931l-58.779 40.129a15 15 0 0 0 0 24.778l58.779 40.129a14.925 14.925 0 0 0 8.444 2.613c4.79 0 9.498-2.29 12.402-6.544 4.671-6.842 2.911-16.175-3.931-20.846zM405.419 176.764l-58.779-40.129c-6.841-4.67-16.174-2.91-20.846 3.931-4.671 6.842-2.911 16.175 3.931 20.846l40.633 27.741-40.633 27.739c-6.842 4.671-8.602 14.004-3.931 20.846 2.905 4.255 7.611 6.544 12.402 6.544 2.913 0 5.857-.847 8.444-2.613l58.779-40.129a15 15 0 0 0 0-24.776zM293.458 122.516c-7.22-4.059-16.366-1.497-20.426 5.726l-60.218 107.123c-4.058 7.22-1.495 16.365 5.727 20.425a14.924 14.924 0 0 0 7.336 1.927c5.244 0 10.336-2.755 13.089-7.652l60.218-107.123c4.06-7.221 1.496-16.366-5.726-20.426z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramType);
export default __webpack_public_path__ + "static/media/program-type.ca413c9edae84d0521e18c77707a7ef6.svg";
export { ForwardRef as ReactComponent };